module.exports = "static/webpack/5106c4340cc8eec9ef8753335c55dcc8.png";